import { initGetterAnalyticsParams } from '@hh.ru/analytics-js';
import makeInit from '@hh.ru/front-static-app';

import PageError from 'src/components/PageError';
import reducer from 'src/modules/appReducer';
import serviceName from 'src/modules/serviceName';
import { getDefaultAnalyticsParams } from 'src/utils/analytics';

import ProxyComponents from 'src/app/proxyComponents';
import routes from 'src/app/routes';

initGetterAnalyticsParams(getDefaultAnalyticsParams);

const init = () =>
    makeInit({
        serviceName,
        proxyComponents: ProxyComponents,
        reducer,
        routes,
        errorComponent: PageError,
    });

export default init;
